<!--
	@component

	The `tags` lets you set the tags as a label-class record. The class is necessary to set the background.
	For example `{"My tag": "bg-blue"}` will make a blue tag with label saying My tag.
-->
<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import type { ProductTagsDefinition } from "./ProductTagsDefinition.js";

	const { tags, class: customClass }: { tags: ProductTagsDefinition; class?: ClassValue } = $props();
	const entries = $derived(Object.entries(tags));
</script>

{#if entries.length > 0}
	<div class={["flex flex-wrap gap-1 z-20", customClass]}>
		{#each entries as [label, { background, class: customClass }] (label)}
			<span
				class={[
					"rounded-full !text-2.5 px-3 flex items-center uppercase py-0 leading-[1.15rem] font-medium border-[1.5px] text-white",
					customClass ?? "font-antipol",
				]}
				style:background
				style:border-color={background}
			>
				{label}
			</span>
		{/each}
	</div>
{/if}
